import React, { useEffect } from 'react';

export const HeaderTokenMiddleware = (props) => {
  // Cutover (§11.2): there is no app token to fetch anymore — the candidate session is the httpOnly
  // cookie, sent automatically. Signal "ready" immediately so the app proceeds to its bootstrap.
  useEffect(() => {
    props.callbackToken();
  }, []);

  return (
    <>

    </>
  );
}
